"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxw_libs_errors_1 = require("mxw-libs-errors");
const bignumber_1 = require("./bignumber");
const bytes_1 = require("./bytes");
const safe_bignumber_1 = require("./safe-bignumber");
const uuid_1 = require("uuid");
function fullHash(fullHash) {
    if (!fullHash) {
        return "";
    }
    return fullHash + " (" + shortHash(fullHash) + ")";
}
exports.fullHash = fullHash;
function shortHash(fullHash) {
    if (isUndefinedOrNull(fullHash) || 0 == fullHash.length) {
        return "000000…000000";
    }
    if (fullHash.startsWith("0x")) {
        fullHash = fullHash.slice(2);
    }
    if (12 >= fullHash.length) {
        return fullHash;
    }
    return fullHash.substr(0, 6) + "…" + fullHash.substr(fullHash.length - 6);
}
exports.shortHash = shortHash;
function isUndefinedOrNull(v) {
    return (undefined === v || null === v || ("number" === typeof v && isNaN(v)));
}
exports.isUndefinedOrNull = isUndefinedOrNull;
function isUndefinedOrNullOrEmpty(v) {
    if (isUndefinedOrNull(v)) {
        return true;
    }
    if ("string" === typeof (v)) {
        if (0 >= v.length) {
            return true;
        }
    }
    else if (Array.isArray(v)) {
        if (0 >= v.length) {
            return true;
        }
    }
    else if ("object" === typeof (v)) {
        if (0 >= Object.keys(v).length) {
            return true;
        }
    }
    return false;
}
exports.isUndefinedOrNullOrEmpty = isUndefinedOrNullOrEmpty;
function isBigNumberUndefinedOrNullOrEmpty(value) {
    return (isUndefinedOrNullOrEmpty(value) || !value.isFinite());
}
exports.isBigNumberUndefinedOrNullOrEmpty = isBigNumberUndefinedOrNullOrEmpty;
function timeNow() {
    return new Date().getTime();
}
exports.timeNow = timeNow;
function timeElapsed(start) {
    let now = new Date().getTime();
    if (start <= now) {
        return now - start;
    }
    return (Number.MAX_VALUE - start) + now;
}
exports.timeElapsed = timeElapsed;
function timeExpired(start, duration) {
    if (0 >= start) {
        return true;
    }
    return (duration <= timeElapsed(start));
}
exports.timeExpired = timeExpired;
function sortObject(obj) {
    if ("object" == typeof obj) {
        let sorted = (Array.isArray(obj)) ? [] : {};
        Object.keys(obj).sort().forEach(function (key) {
            if (obj[key] == null)
                sorted[key] = obj[key];
            else if ("object" == typeof obj[key] && 0 < Object.keys(obj[key]).length) {
                sorted[key] = sortObject(obj[key]);
            }
            else {
                if (Array.isArray(sorted)) {
                    sorted.push(obj[key]);
                }
                else {
                    sorted[key] = obj[key];
                }
            }
        });
        return sorted;
    }
    return obj;
}
exports.sortObject = sortObject;
function iterate(obj, modifier) {
    if (obj && "object" == typeof obj) {
        let modified = (Array.isArray(obj)) ? [] : {};
        Object.keys(obj).forEach(function (key) {
            let data = obj[key];
            if (undefined != data) {
                let type = data.constructor ? data.constructor.name : null;
                if ("object" == typeof data && 0 < Object.keys(data).length) {
                    if (modifier) {
                        data = modifier.apply(obj, [key, data, type]);
                    }
                    modified[key] = iterate(data, modifier);
                }
                else {
                    if (modifier) {
                        data = modifier.apply(obj, [key, data, type]);
                    }
                    if (Array.isArray(modified)) {
                        modified.push(data);
                    }
                    else {
                        modified[key] = data;
                    }
                }
            }
        });
        return modified;
    }
    return obj;
}
exports.iterate = iterate;
function convertObject(object, convert, depth) {
    if ("object" == typeof object) {
        let stringified = (Array.isArray(object)) ? [] : {};
        Object.keys(object).forEach(function (key) {
            if ("object" == typeof object[key] && 0 < Object.keys(object[key]).length) {
                stringified[key] = sortObject(object[key]);
            }
            else {
                let value = ("function" === typeof object.toString) ? object.toString() : JSON.stringify(object);
                if (Array.isArray(stringified)) {
                    stringified.push(value);
                }
                else {
                    stringified[key] = value;
                }
            }
        });
        return stringified;
    }
    return object;
}
exports.convertObject = convertObject;
function checkFormat(format, object) {
    let result = {};
    for (let key in format) {
        try {
            if ('function' !== typeof (format[key]))
                result[key] = checkFormat(format[key], object[key]);
            else {
                let value = format[key](object[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
        }
        catch (error) {
            if (undefined === object[key]) {
                mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.PARAMETER_MISSING, 'missing object key ' + key, {
                    key,
                    object
                });
            }
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_FORMAT, 'invalid format object key ' + key + ": " + error.message, {
                value: object[key],
                key,
                object
            });
        }
    }
    return result;
}
exports.checkFormat = checkFormat;
function allowNull(check, nullValue) {
    return (function (value) {
        if (value == null) {
            return nullValue;
        }
        return check(value);
    });
}
exports.allowNull = allowNull;
function notAllowNull(check) {
    return (function (value) {
        if (value == null) {
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'is null');
        }
        return check(value);
    });
}
exports.notAllowNull = notAllowNull;
function allowNullOrEmpty(check, nullValue) {
    return (function (value) {
        if (value == null || '' === value) {
            return nullValue;
        }
        return check(value);
    });
}
exports.allowNullOrEmpty = allowNullOrEmpty;
function notAllowNullOrEmpty(check) {
    return (function (value) {
        if (isUndefinedOrNullOrEmpty(value)) {
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'empty');
        }
        return check(value);
    });
}
exports.notAllowNullOrEmpty = notAllowNullOrEmpty;
function expectTypeOf(check, type) {
    return (function (value) {
        if (type !== typeof value) {
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_FORMAT, "expected type " + type + ", but " + (typeof value));
        }
        return check(value);
    });
}
exports.expectTypeOf = expectTypeOf;
function arrayOf(check) {
    return (function (array) {
        if (!Array.isArray(array)) {
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'not an array');
        }
        let result = [];
        array.forEach(function (value) {
            result.push(check(value));
        });
        return result;
    });
}
exports.arrayOf = arrayOf;
function checkHash(hash, requirePrefix) {
    if (typeof (hash) === 'string') {
        // geth-etc does add a "0x" prefix on receipt.root
        if (!requirePrefix && hash.substring(0, 2) !== '0x') {
            hash = '0x' + hash;
        }
        if (bytes_1.hexDataLength(hash) === 32) {
            return hash.toLowerCase();
        }
    }
    return mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid hash - ' + hash);
}
exports.checkHash = checkHash;
function checkBigNumber(value) {
    return bignumber_1.bigNumberify(value);
}
exports.checkBigNumber = checkBigNumber;
function checkNumber(value, config) {
    return checkSafeBigNumber(value, config).toNumber();
}
exports.checkNumber = checkNumber;
function checkNumberString(value, config) {
    return checkSafeBigNumber(value, config).toNumber().toString();
}
exports.checkNumberString = checkNumberString;
function checkSafeBigNumber(value, config, mode) {
    return safe_bignumber_1.safeBigNumberify(value, config, mode);
}
exports.checkSafeBigNumber = checkSafeBigNumber;
function checkSafeBigNumberString(value, config) {
    return safe_bignumber_1.safeBigNumberify(value, config).toString();
}
exports.checkSafeBigNumberString = checkSafeBigNumberString;
function checkBoolean(value) {
    if (typeof (value) === 'boolean') {
        return value;
    }
    if (typeof (value) === 'string') {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
    }
    return mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid boolean - ' + value);
}
exports.checkBoolean = checkBoolean;
function checkString(string) {
    if (typeof (string) !== 'string') {
        mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid string');
    }
    return string;
}
exports.checkString = checkString;
function checkTimestamp(string) {
    if (typeof (string) !== 'string') {
        mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid timestanmp');
    }
    return string;
}
exports.checkTimestamp = checkTimestamp;
function checkAddress(string) {
    if (typeof (string) !== 'string') {
        mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid address');
    }
    return string;
}
exports.checkAddress = checkAddress;
function checkHex(string) {
    if (typeof (string) === 'string') {
        if (!string.startsWith("0x"))
            string = "0x" + string;
        if (bytes_1.isHexString(string))
            return string;
    }
    return mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid hex - ' + string);
}
exports.checkHex = checkHex;
function checkHexAddress(string) {
    if (typeof (string) === 'string') {
        if (!string.startsWith("0x"))
            string = "0x" + string;
        if (bytes_1.isHexString(string))
            return string;
    }
    return mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.INVALID_PARAMETER, 'invalid hex address - ' + string);
}
exports.checkHexAddress = checkHexAddress;
function checkAny(value) {
    return value;
}
exports.checkAny = checkAny;
function generateId(seed = 0, random = 0) {
    let id = uuid_1.v1();
    let hex = "0x" + id.substr(15, 3) + id.substr(9, 4) + id.substr(0, 8);
    if (0 < seed) {
        seed = (seed * 100);
    }
    seed += random;
    return safe_bignumber_1.safeBigNumberify(hex).plus(seed).toString();
}
exports.generateId = generateId;
//# sourceMappingURL=utils.js.map